import React from 'react'

function IconToDo() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={27}
            height={27}
            viewBox="0 0 27 27"
            fill="none"
        >
            <rect width={27} height={27} fill="url(#pattern0_2085_31)" />
            <defs>
                <pattern
                    id="pattern0_2085_31"
                    patternContentUnits="objectBoundingBox"
                    width={1}
                    height={1}
                >
                    <use xlinkHref="#image0_2085_31" transform="scale(0.01)" />
                </pattern>
                <image
                    id="image0_2085_31"
                    width={100}
                    height={100}
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACqElEQVR4nO3dMWsUQRjG8VHB3AxiiKVIhLsZhbQ2dvYqWC3Em/e0sTd+AgvR7+IHsBVEbKxs/AKiWAgplCAW8WRz4l0uqxbZ7Dzc/n9w3UGGfbNv3pndhzjXER8nlU+2G1Le9zE/6ernosHZ4d0UUt4LyaazT95f3xxvcLGKeHw6xPx6Xgyb+pi/ukuVL7OenvMx7ywW43dBHpZeVy+tpfEwRPt2uCD5jXPVmdJr62mrsldLxdir/56UXlkv+WiPaFUiaFVSaFVSaFVCaFVSaFWtCGlyMyT7EKJ9CnF8u+UN4E47q+yRg0LM9wnffczXj39WZdP6uKS+a05m1Svs4O5Y/K1O+fNgONk8zllVmxvAsHTXrfrHDZJth2Q/l1rNO7dVnVNoVaFvBZldVHvacFFf/O/MqYupKvSxIM65UyHZ84aiPCs9VYWeFsTVzydCtLdHvnQlP2i6UGwAO+Cvbl8MMX88VJBoPwZxcmPxe2wAOxRG42vLI6yP9mUt3hvNvsEGsHP1CwlHJq9k7zeG1TqtqpDGySvZSzaA5TROXic9VeFf/jZ5zcdiXlaQmLxmdwcvK+hMXrSq4kLKt+qT4frw0Y/Gd0qvBwAAAH9cvj84v1Vd4IoIIEElhASVFBJUUkhQCeFRrxQe9UrhUa8QWpUUWpUUWpUQWpUUWlUrSFCJIUElhgSVacURSFCZXj6EBJVpFYQElckVhASVIhJUgkhQCSJBJYgElR4SVHJIUOkhQSWIBJUgElQAAAAAAKwcUrg6SOEKIYUrhRSuFFK4QsiLSCEvIoVomxBalRRalRRalRBalRRaVStI4YohhSuGFK5pRdpI4ZpexpAUrsmFPvk/hkmrIKRwFZHCFUQKVxApXEGkcPWQwpVDClcPKVxBpHAFkcJ1nfgFhdkl8t7Fd/AAAAAASUVORK5CYII="
                />
            </defs>
        </svg>

    )
}

export default IconToDo
